/* global System */
// register component(s) with react habitat

export default { CountNumber: () => System.import('./CountNumber') }
